import React from 'react';
import Button from './Button';

const ContactButton = ({ children, className = '', size }) => {
  const handleClick = () => {
    const $btn = document.getElementById('formbutton-button');
    if ($btn) $btn.click();
  };

  return (
    <Button className={className} size={size} onClick={handleClick}>
      {children}
    </Button>
  );
};

export default ContactButton;
